// @ts-nocheck

import Input from 'antd/lib/input';
import Button from 'antd/lib/button';
import type { FieldInputProps, FormikHelpers, FormikProps } from 'formik';
import { connect } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';

import { Form } from './../../components';
import type { FormFieldType } from './../../components/Form';
import { login } from './../../ducks/auth';
import type { Credentials } from './../../lib/types';

type FormErrors = Partial<Record<keyof Credentials, string | null>>;

type Login = (credentials: Credentials) => Promise<void>;

export type LoginFormProps = {
  login: Login;
};

export const LoginForm = ({ login }: LoginFormProps) => {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <Form
      validate={(values: Credentials): FormErrors => {
        const errors: FormErrors = {};
        if (!values.userName) {
          errors.userName = 'Обязательно для заполнения';
        }
        if (!values.password) {
          errors.password = 'Обязательно для заполнения';
        }

        return errors;
      }}
      onSubmit={async (
        values: Credentials,
        { setErrors }: FormikHelpers<Credentials>
      ) => {
        try {
          await login(values);
          const target =
            (location.state as { uri?: string } | null | undefined)?.uri ?? '/';
          navigate(target, { replace: true });
        } catch (error) {
          const errors: FormErrors = {
            userName: null,
            password: 'Неверные логин или пароль',
          };
          setErrors(errors as Parameters<FormikHelpers<Credentials>['setErrors']>[0]);
        }
      }}
    >
      {(FormField: FormFieldType, formikProps: FormikProps<Credentials>) => {
        const { handleSubmit, isSubmitting } = formikProps;
        return (
          <StyledForm onSubmit={handleSubmit}>
            <Wrapper>
              <FormField label="E-mail" name="userName">
                {(field: FieldInputProps<string>) => (
                  <Input
                    {...field}
                    placeholder="Введите e-mail"
                    size="large"
                  />
                )}
              </FormField>
              <FormField label="Пароль" name="password">
                {(field: FieldInputProps<string>) => (
                  <Input
                    {...field}
                    placeholder="Введите пароль"
                    size="large"
                    type="password"
                  />
                )}
              </FormField>
              <Button
                disabled={isSubmitting}
                loading={isSubmitting}
                type="primary"
                htmlType="submit"
                className="login-form-button"
                data-cy="login"
                style={{ marginTop: 10 }}
              >
                Войти
              </Button>
            </Wrapper>
          </StyledForm>
        );
      }}
    </Form>
  );
};

export default connect(null, {
  login,
})(LoginForm);

const StyledForm = styled.form`
  display: flex;
  justify-content: flex-start;
  align-items: stretch;
`;

const Wrapper = styled.div`
  width: 100%;
`;
